import { render, staticRenderFns } from "./DropdownControl.vue?vue&type=template&id=56df79f5&scoped=true&"
import script from "./DropdownControl.vue?vue&type=script&lang=js&"
export * from "./DropdownControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56df79f5",
  null
  
)

export default component.exports